/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-underscore-dangle */
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { v4 as uuid } from 'uuid';
// import { useSelector } from 'react-redux';
import {
    CurrencyIcon,
    FormattedDate,
} from '@ya.praktikum/react-developer-burger-ui-components';
import styles from './order-history-details.module.css';
import {
    OrderStatus,
    OrderStatusColor,
    TIngredientType,
    TwsOrder,
} from '../../utils/types';
import { useSelector, RootState, useDispatch } from '../../services/store';
import { getOrderDetails } from '../../services/thunks';
import IngredientElement from '../ingredient-element/ingredient-element';

function OrderHistorytDetails(): JSX.Element {
    const { id } = useParams();
    const dispatch = useDispatch();
    const all = useSelector((store: RootState) => store.fetch.data);
    const items: { [itemID: string]: TIngredientType } = {};
    if (all) {
        all.forEach((item) => {
            items[item._id] = item;
        });
    }

    useEffect(() => {
        dispatch(getOrderDetails(Number(id)));
    }, []);

    const order: TwsOrder | null = useSelector(
        (store: RootState) => store.order.details
    );
    return (
        <div style={{ paddingTop: '-20px' }}>
            {order && (
                <div className={`${styles.card_details}`}>
                    <div
                        className={`${styles.card_text} text text_type_main-medium`}
                    >
                        #{order.number}
                    </div>
                    <div
                        className={`${styles.card_text} text text_type_main-default`}
                    >
                        {order.name}
                    </div>
                    <div
                        style={{ color: OrderStatusColor[order.status] }}
                        className="text text_type_main-small"
                    >
                        {OrderStatus[order.status]}
                    </div>
                    <div className={styles.card_text}>Состав:</div>
                    <div className={styles.card_container}>
                        {order.ingredients.map((i) => (
                            <div
                                key={uuid()}
                                style={{
                                    display: 'inline-flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    paddingLeft: '24px',
                                }}
                            >
                                <div>
                                    <IngredientElement item={items[i]} />
                                </div>
                                <div className="pl-4">{items[i].name}</div>
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignSelf: 'right',
                                        margin: '0px 20px 0px 0px',
                                    }}
                                >
                                    <div className="pl-4 pr-4">
                                        {items[i].price}
                                    </div>
                                    <CurrencyIcon type="primary" />
                                </div>
                            </div>
                        ))}
                    </div>
                    <div
                        className={styles.card_text}
                        style={{
                            display: 'inline-flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        }}
                    >
                        <FormattedDate date={new Date(order.createdAt)} />
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                            }}
                        >
                            <div className="pr-4">
                                {order.ingredients.reduce(
                                    (p, c) =>
                                        p + (items[c] ? items[c].price : 0),
                                    0
                                )}
                            </div>
                            <CurrencyIcon type="primary" />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default OrderHistorytDetails;
